import React, {useMemo} from 'react';
import SentryEchart from "../../../../components/echarts/sentry-echart.jsx";
import useGraphViewportWidth from "../../../../hooks/use-graph-viewport-width.js";
import {DASH_BREAKPOINTS, fluidPx} from "../../../../utils/responsive-graph.js";

const DutyGarrisonStatus = ({data, className, height}) => {
    const vw = useGraphViewportWidth();

    const option = useMemo(() => {
        const isCompact = vw < DASH_BREAKPOINTS.desktop;
        const legendFs = fluidPx(11, 24, vw);
        const legendValues = {
            'Em despacho': data.unavailable,
            'Livre': data.available
        };

        const pieCenter = isCompact ? ['25%', '38%'] : ['25%', '50%'];
        const pieRadius = isCompact ? ['50%', '75%'] : ['65%', '95%'];

        const legendLayout = isCompact
            ? {left: '35%', top: '0%', orient: 'vertical'}
            : {left: '55%', top: '35%', orient: 'vertical'};

        return {
            tooltip: {
                show: true,
                formatter: (params) => `${params.name}: ${params.value} (${params.percent.toFixed(0)}%)`
            },
            title: {show: false},
            legend: {
                ...legendLayout,
                icon: 'circle',
                textStyle: {
                    color: '#FDFCFF',
                    fontSize: legendFs
                },
                formatter: (name) => `${name}: ${legendValues[name] ?? 0}`
            },
            series: [
                {
                    type: 'pie',
                    radius: pieRadius,
                    center: pieCenter,
                    silent: true,
                    animation: false,
                    tooltip: {show: false},
                    label: {show: false},
                    labelLine: {show: false},
                    z: 1,
                    data: [
                        {
                            value: 1,
                            itemStyle: {
                                color: 'rgba(255, 255, 255, 0.08)'
                            }
                        }
                    ]
                },
                {
                    type: 'pie',
                    radius: pieRadius,
                    center: pieCenter,
                    avoidLabelOverlap: true,
                    z: 2,
                    itemStyle: {
                        borderRadius: 20
                    },
                    label: {show: false},
                    data: [
                        {
                            value: data.unavailable,
                            name: 'Em despacho',
                            itemStyle: {color: '#004893'}
                        },
                        {
                            value: data.available,
                            name: 'Livre',
                            itemStyle: {color: '#2ACBE2'}
                        }
                    ],
                    labelLine: {
                        show: false
                    }
                }
            ],
        };
    }, [data, vw]);

    return (
        <SentryEchart
            className={className}
            option={option}
            height={height}
            title={"Ocupação"}
        />
    );
};

export default DutyGarrisonStatus;
